$(document).ready(function($){

    $('.scrollspy').scrollSpy({
        scrollOffset: 100,
        activeClass: 'active'
    });

    $('input[name="lottery-date"]').attr('onfocusin', '(this.type=\'date\')');
    $('input[name="lottery-date"]').attr('onfocusout', '(this.type=\'text\')');

    let bodyClass = $('body').hasClass('home');
    let newUrl;
    if(bodyClass != true) {
        $('.navbar-nav li a, .side-nav li a, .footer-nav li a').attr('href', function(i, href) {
            i = $(this).attr('href');
            if (i != '#modal-instrukcja' && i != '#calculator_modal') {
                newUrl = i.replace('#', '/#');
                return href.replace(href, newUrl);
            }
        });
    }

    // collapse 'show more' function

    const collapse = $('.wp-block-ub-content-toggle.theme-collapse .wp-block-ub-content-toggle-accordion');
    const buttonMore = $('<div class="btn-wrap"><button id="btn-more" class="btn btn-more">więcej</button></div>');
    let size_collapse = collapse.length;
    let x = 3;
    collapse.addClass('hide');
    collapse.parent().append(buttonMore);
    $('.wp-block-ub-content-toggle.theme-collapse .wp-block-ub-content-toggle-accordion:lt('+x+')').removeClass('hide');

    buttonMore.on('click', function(e) {
        e.preventDefault();
        if (x+5 <= size_collapse) {
            x = x+5;
            $('.wp-block-ub-content-toggle.theme-collapse .wp-block-ub-content-toggle-accordion:lt('+x+')').removeClass('hide');
        } else {
            x = size_collapse;
            $('.wp-block-ub-content-toggle.theme-collapse .wp-block-ub-content-toggle-accordion:lt('+x+')').removeClass('hide');
            buttonMore.hide();
        }
    })


});

// last single letter on paragraph return to new line
// document.body.innerHTML = document.body.innerHTML.replace(/\s([a-z])\s/g, ' $1&nbsp;');
